import React from 'react';

const EndGameModal = ({
  isOpen,
  onClose,
  didWin,
  correctMovieDetails,
  onReset,
  onShare,
  totalGames,
  winPercentage,
  currentScore,
  highScore
}) => {
  if (!isOpen || !correctMovieDetails.title) {
    return null;
  }

  const handleClose = () => {
    onClose();
  };

  return (
    <div className="modal-backdrop end-game-modal" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{didWin ? "Congratulations!" : "Game Over"}</h2>
          <button onClick={handleClose} className="close-button">&times;</button>
        </div>
        <div className="modal-body">
          {didWin
            ? <p>You've guessed correctly! The movie is: <strong>{correctMovieDetails.title}</strong>.</p>
            : <p>Better luck next time! The correct movie was: <strong>{correctMovieDetails.title}</strong>.</p>}
          <p>Total Games Played: <strong>{totalGames}</strong></p>
          <p>Win Percentage: <strong>{winPercentage}%</strong></p>
          <p>Game Score: <strong>{currentScore}</strong></p>
          <p>High Score: <strong>{highScore}</strong></p>
        </div>
        <div className="modal-footer">
          <button onClick={onReset}>Play Again</button>
          <button onClick={onShare}>Share</button>
          <button onClick={handleClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default EndGameModal; 